import type { ReactNode } from 'react';

import { styled } from '@mend/mui';
import { Delete } from '@mui/icons-material';
import { Box, Button, Divider, Stack, Typography } from '@mui/material';

const FiltersGrid = styled('div')<{ gap?: number }>(({ theme, gap = 3 }) => ({
  padding: theme.spacing(2),
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: theme.spacing(gap),
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  },
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
  },
}));

export function FiltersPanel(props: {
  children: ReactNode;
  onRemoveAll: () => void;
  gap?: number;
}) {
  return (
    <Box data-testid="filters-panel" width="1200px">
      <Stack direction="row" alignItems="center" px={2} pt={2} pb={1}>
        <Typography variant="subtitle1">Filters</Typography>
      </Stack>
      <Divider />

      <FiltersGrid gap={props.gap}>{props.children}</FiltersGrid>

      <Divider />
      <Stack direction="row" justifyContent="flex-end" px={2} py={1}>
        <Button
          variant="text"
          color="primary"
          onClick={props.onRemoveAll}
          aria-label="Remove all filters"
          startIcon={<Delete />}
        >
          Remove All
        </Button>
      </Stack>
    </Box>
  );
}
